export default class CashBankBookActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_CASHBANKBOOK='GET_HELPER_CASHBANKBOOK';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: CashBankBookActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: CashBankBookActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: CashBankBookActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: CashBankBookActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: CashBankBookActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: CashBankBookActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: CashBankBookActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: CashBankBookActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: CashBankBookActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: CashBankBookActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: CashBankBookActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: CashBankBookActions.GET_HELPER_CASHBANKBOOK,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: CashBankBookActions.ERROR_SERVER,
      payload: error
    };
  }
}